import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import withWidth from '@material-ui/core/withWidth'
import AdminHeaderContainer from 'containers/AdminHeaderContainer'
import AdminModalConductor from 'containers/AdminModalConductor'

export const AdminLayout = ({ children, location, width }) => (
  <div>
    <AdminHeaderContainer location={location} />
    <AdminModalConductor />
    <div className={width === 'xs' ? 'pageAdminXs' : 'pageAdmin'}>
      {children}
    </div>
  </div>
)

AdminLayout.propTypes = {
  location: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
  children: PropTypes.node
}

export default withRouter(withWidth()(AdminLayout))



// WEBPACK FOOTER //
// ./src/layouts/AdminLayout/AdminLayout.js